/*=========================================================================================
  File Name: moduleImmoState.js
  Description: Immo Module State.
              Used
              for the Immo subscription tunnel / src / views / Immo
==========================================================================================*/
const state = {
  search: {
    city: "",
    zipCode: "",
    types: [],
    budgetMin: 0,
    budgetMax: 0,
    surfaceMin: 0,
    surfaceMax: 0,
    hasBalcon: false,
    hasTerasse: false,
    hasLoggia: false,
    hasCave: false,
    hasParking: false,
    hasJardin: false,
    isRezChaussee: false,
    isDernierEtage: false,
    isDuplex: false,
    noRezChaussee: false,
    isPiscine: false,
    hasGardien: false,
    hasAscenseur: false,
    isBackToSearch: false,
    currentPage: 1,
    totalPages: 1,
  }
};
export default state;